import { useGetSinglePage } from 'react-easyrocket';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation, useNavigate } from 'react-router';
import { twJoin } from 'tailwind-merge';
import { Logo } from 'src/config/components/Logo';
import { CONTENT_PAGES } from 'src/constants/contentPages';
import { useRoute } from 'src/router/hooks/useRoute';

const LINKS_STYLES = 'text-sm mb-1 w-auto first-letter:uppercase lowercase';

export const FooterNavLinksBlock = () => {
  const { childs } = useGetSinglePage(CONTENT_PAGES.INFO);
  const { t } = useTranslation();
  const { ROUTE } = useRoute();
  const location = useLocation();
  const navigate = useNavigate();

  const isMainPage = location.pathname === ROUTE.MAIN.get();

  const handleFooterLogoClick = () => {
    if (isMainPage) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    } else navigate(ROUTE.MAIN.get());
  };

  return (
    <div className="flex 768:justify-between 768:flex-row w-full items-center pb-8 flex-col-reverse justify-center gap-8">
      <div className="w-full 768:w-1/2 flex 768:flex-row justify-start items-center 768:flex-wrap gap-2 768:gap-4 flex-col">
        {childs?.map((item, index) => (
          <NavLink
            aria-label={`${t(item.title)}`}
            to={ROUTE.INFO_PAGES_CODE.get(item.code)}
            key={index}
            className={({ isActive }) =>
              isActive ? 'text-f_text_active' : 'text-f_text hover:!text-f_text_active'
            }>
            <p className={LINKS_STYLES}>{t(item.title)}</p>
          </NavLink>
        ))}
        <NavLink
          to={ROUTE.FAQ.get()}
          aria-label={'Faq'}
          className={({ isActive }) =>
            isActive ? 'text-f_text_active' : 'text-f_text hover:!text-f_text_active'
          }>
          <p className={twJoin(LINKS_STYLES, 'uppercase')}>Faq</p>
        </NavLink>
      </div>
      <Logo className="max-w-[250px] cursor-pointer" onClick={handleFooterLogoClick} />
    </div>
  );
};
